import styled from 'styled-components';

export const UnexpectedErrorStyled = styled.div`
  background-color: '#f6f6f6';
  flex: '1';
`;
